module.exports = __webpack_public_path__ + "img/SplashScience3.e6b5d8c7.jpg";